import { useEffect, useMemo } from "react";

import { useAppDispatch } from "../redux/hooks";
import {
  CourtOption,
  CourtView,
  setCourtOptions,
  setCourtViews,
  useGetUser,
  useLazyGetPlayingSurfaceByIdQuery,
} from "../redux/slices";

export const useSetCourtOptions = () => {
  const { user } = useGetUser();
  const dispatch = useAppDispatch();
  const [getCourtByLeague, court] = useLazyGetPlayingSurfaceByIdQuery();
  const league = useMemo(
    () => user?.products?.FASTDRAW2?.[0]?.account?.properties?.find((property) => property.key === "league_id")?.value,
    [user]
  );

  useEffect(() => {
    if (league) {
      getCourtByLeague({ id: league }, true);
    }
  }, [getCourtByLeague, league]);

  useEffect(() => {
    const courtOptions: CourtOption[] = [];
    const courtViews: CourtView[] = [];

    if (court.data) {
      for (const courtOption in court.data.drawData.info.defaultSportElementLabels) {
        courtOptions.push({
          id: courtOption,
          label: court.data.drawData.info.defaultSportElementLabels[courtOption] || "",
        });
      }

      for (const courtView in court.data.drawData.info.courtViews) {
        courtViews.push({
          id: courtView,
          viewBox: court.data.drawData.info.courtViews[courtView]?.viewBox || "",
          width: court.data.drawData.info.courtViews[courtView]?.width || 0,
          height: court.data.drawData.info.courtViews[courtView]?.height || 0,
          label: court.data.drawData.info.courtViews[courtView]?.label || "",
        });
      }

      dispatch(setCourtOptions({ courtOptions }));
      dispatch(setCourtViews({ courtViews }));
    }
  }, [court, dispatch]);
};
